import React from 'react';
import { connect } from 'react-redux';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const LegalPopup = (props) => {
    const onTermsOfferClick = (e) => {
        if (props.legal_mca_terms) {
            e.preventDefault();
            props.popupRef.current?.open(
                <SimplePopup withoutBorder popupRef={props.popupRef}>
                    <PopupButton
                        href={props.legal_terms}
                        target="_blank"
                        iconName="scales"
                        text={props.termsEuPlcOffer}
                        onClick={props.popupRef.current?.close()}
                    />
                    <PopupButton
                        href={props.legal_mca_terms}
                        target="_blank"
                        iconName="scales"
                        text={props.termsEuPlcMcaOffer}
                        onClick={props.popupRef.current?.close()}
                    />
                </SimplePopup>,
            );
        } else {
            props.popupRef.current?.close();
        }
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton href={props.legal_terms} target="_blank" iconName="scales" text={props.termsOffer} onClick={onTermsOfferClick} />
            {props.legal_policy && (
                <PopupButton
                    href={props.legal_policy}
                    target="_blank"
                    iconName="eye"
                    text={props.policyEuPlcOffer}
                    onClick={() => props.popupRef.current?.close()}
                />
            )}
            {props.paysend_plus_terms && (
                <PopupButton
                    href={props.paysend_plus_terms}
                    target="_blank"
                    iconName="plus-rounded"
                    text={props.paysendPlusTerms}
                    onClick={() => props.popupRef.current?.close()}
                />
            )}
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        legal_terms: state.extra.legal_terms,
        legal_mca_terms: state.extra.legal_mca_terms,
        legal_policy: state.extra.legal_policy,
        paysend_plus_terms: state.extra.paysend_plus_terms,
        termsOffer: state.messages.pageMessages.termsOffer,
        termsEuPlcOffer: state.messages.pageMessages.termsEuPlcOffer,
        termsEuPlcMcaOffer: state.messages.pageMessages.termsEuPlcMcaOffer,
        policyEuPlcOffer: state.messages.pageMessages.policyEuPlcOffer,
        paysendPlusTerms: state.messages.pageMessages.paysendPlusTerms,
    };
};
export default connect(mapStateToProps, null)(LegalPopup);
